import {
  Channel,
  ChannelMapIcon,
  ChannelMapImg,
  ChannelDetailHost,
  SORT_TYPE,
  FollowType,
  VideoType,
  RoleType,
  RoleEmojiMap,
  DEMAND_STATUS,
} from '@da-vinci/shared'

export enum ChannelSourceScreen {
  currentUser = 'currentUser',
  otherUser = 'otherUser',
}

export const ChannelNameMap = {
  [Channel.xiaohongshu]: t('小红书'),
  [Channel.douyin]: t('抖音'),
}

export const VideoTypeNameMap: Record<VideoType, string> = {
  [VideoType.ad]: t('广告'),
  [VideoType.kol]: t('KOL视频'),
  [VideoType.verified]: t('蓝V视频'),
}

export const NormalSortOpt = [
  { label: '最近更新', value: 'modifyDesc' },
  { label: '最早创建', value: 'createAsc' },
] as const
export type NormalSortOptType = typeof NormalSortOpt[number]['value']

export {
  Channel,
  ChannelMapIcon,
  ChannelMapImg,
  ChannelDetailHost,
  SORT_TYPE,
  FollowType,
  VideoType,
  RoleType,
  RoleEmojiMap,
  DEMAND_STATUS,
}
